import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPermissions } from "../../api/request/permission";

export const fetchPermissions = createAsyncThunk(
  "permission/fetchPermissions",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await getAllPermissions({ userId });
      if (data?.success) return data?.data?.permissions || [];
      return [];
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    permissions: [],
    isLoading: false,
  },
  reducers: {
    clearPermissions: (state) => {
      state.permissions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
